import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getRankingListAction } from '../../../actions/advisor';
import ReactPaginate from 'react-paginate';
import { backendUrl, HOLDERS } from '../../../constants';
import Podium from './Podium';
import StartMessageModel from '../../../components/message/StartMessageModel';
import RankBadge from './RankBadge';

export default function RankingTable() {
    const dispatch = useDispatch()
    const { rankingList, rankingListCount, topThreeAdvisors, currentUser } = useSelector(state => state.advisor);
    const { user } = useSelector((state) => state.user);
    const [currentSelection, setCurrentSelection] = useState(null);
    const [messageModal, setMessageModal] = useState(false);
    const limit = 10
    const [page, setPage] = useState(1)
    const [activePage, setActivePage] = useState(0)

    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        setActivePage(selectedPage);
        setPage(selectedPage + 1);
    };

    useEffect(() => {
        dispatch(getRankingListAction(page, limit))
    }, [dispatch, page])

    const handleMessage = (list) => {
        setCurrentSelection(list)
        setMessageModal(true);
    };

    return (
        <div className="">
            <div className="panel">
                <div className="row cashHederSectionPadding">
                    <div className="col-md-6 col-6 button_align">
                        <h6 className="cashHeaderText cashDarkText m-0">Ranking table</h6>
                    </div>
                </div>
                {/* <Card.Header className="fw-semibold caompanyHeader panel-head">Ranking table</Card.Header> */}
                {rankingList?.length > 0 ?
                    <>
                        <div className='innercardClass'>
                            <div className="p-3 p-md-4">
                                <div className="row g-4 align-items-center">
                                    <div className="col-lg-8 innerleaderboardSection">
                                        <h5 className="fw-bold mb-2">Climb the leaderboard and get recognized.</h5>
                                        <p className="text-secondary mb-0">
                                            The top 10 advisors get featured and celebrated! Boost your score by inviting new promoters or
                                            helping them start sandboxes. Show your leadership—let the world see your name shine!
                                        </p>
                                    </div>
                                    <div className="col-lg-4 rankingimg">
                                        <Podium rankingList={topThreeAdvisors} />
                                    </div>
                                </div>
                            </div>
                            <div className="rank-head px-3 px-md-4 py-3">
                                <div className="row fw-medium headertextClass ">
                                    <div className="col-2 col-md-2 text-center">Rank</div>
                                    <div className="col-5 col-md-5 text-center">Name</div>
                                    <div className="col-2 col-md-2 text-center">Score</div>
                                    <div className="col-3 col-md-3 text-center">Action</div>
                                </div>
                            </div>
                            {currentUser &&
                                <div className="rank-row rank-row-current">
                                    <div className="row align-items-center">
                                        <div className="col-2 col-md-2 align-items-center text-center" style={{ paddingLeft: '25px' }}>
                                            <RankBadge row={currentUser} />
                                        </div>
                                        <div className='col-5 col-md-5 tableimganmeMain'>
                                            <div className="tableimganme">
                                                <img className="rounded-circle" src={currentUser?.profilePic ? backendUrl + currentUser?.profilePic?.filename : "assets/img/Frame1.svg"} width="44" height="44" alt="" />
                                                <div>
                                                    <div className="nameUser fw-medium">{currentUser.first_name || "-"}{" "}{currentUser.last_name || ""}</div>
                                                    <div className="subuserHeading fw-normal">Advisor</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-2 col-md-2 scrowTxt text-center">{currentUser.score}</div>
                                    </div>
                                </div>
                            }
                            <div className="scroll-area">
                                {rankingList?.length > 0 && rankingList?.map((row, index) => (
                                    <div className="rank-row" key={row._id}>
                                        <div className="row align-items-center">
                                            <div className="col-2 col-md-2 align-items-center text-center" style={{ paddingLeft: '25px' }}>
                                                <RankBadge row={row} />
                                            </div>
                                            <div className='col-5 col-md-5 tableimganmeMain'>
                                                <div className="tableimganme">
                                                    <img className="rounded-circle" src={row?.profilePic ? backendUrl + row?.profilePic?.filename : "assets/img/Frame1.svg"} width="44" height="44" alt="" />
                                                    <div>
                                                        <div className="nameUser fw-medium">{row.first_name || "-"}{" "}{row.last_name || ""}</div>
                                                        <div className="subuserHeading fw-normal">Advisor</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-2 col-md-2 scrowTxt text-center">{row.score}</div>
                                            {user?.id !== row?._id &&
                                                <div onClick={() => handleMessage(row)} className="col-3 col-md-3 mt-2 mt-md-0 text-center">
                                                    <span className="invite">Send message</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                )
                                )}
                            </div>
                        </div>
                        {rankingListCount > 0 &&
                            <div className="py-3 d-flex align-items-center justify-content-end px-3">
                                <ReactPaginate
                                    previousLabel={<i className="fas fa-chevron-left"></i>} // Font Awesome icon for previous
                                    nextLabel={<i className="fas fa-chevron-right"></i>} // Font Awesome icon for next
                                    pageCount={rankingListCount}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={2}
                                    onPageChange={handlePageClick}
                                    containerClassName={"pagination customPagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={activePage}
                                />
                            </div>
                        }
                    </>
                    :
                    <div className='noRankingSection'>
                        <div className="text-center rankings-card">
                            <img src="./assets/img/podium.png" className="img-fluid mb-3" alt="Podium" />
                            <div className="noRankingClass">🎖️ No rankings yet!</div>
                            <p className="m-0">
                                Start growing your influence by inviting others or creating your first sandbox.
                                Once you've earned points, you'll appear here!
                            </p>
                            {/* <button type="button" className='customFilterButton mobileViewImportButton'>
                                Send invite
                            </button> */}
                        </div>
                    </div>
                }
            </div>
            <StartMessageModel
                messageModal={messageModal}
                addModalClose={() => setMessageModal(false)}
                currentSelection={currentSelection}
                type={HOLDERS.advisor}
            />
        </div>
    )
}